import {
	CHILLNN_ROOM_RANK_PLAN_ID,
	CHILLNN_ROOM_RANK_PLAN_NAME,
	ROOM_RATE_PLAN_ID,
	ROOM_RATE_PLAN_NAME,
} from "../constants";
import { DAILY_RATE_CELL_STATUS_LABEL, type PlanRoomDailyRateRow } from "../types";

export type PublishedRoom = {
	roomID: string;
	roomName: string;
};

const unregisteredCell = {
	status: "unregistered" as const,
	priceYen: null,
	displayLabel: DAILY_RATE_CELL_STATUS_LABEL.unregistered,
};

/**
 * 擬似プラン（プランなし／部屋料金）の行が無い公開中の部屋を、未設定セルの行として足す。
 * 連携プラン行だけある部屋は、部屋料金を絞り込むと表から消えるため、擬似プラン単位で欠けを見る。
 * 料金の正本は API のまま。画面だけ欠けを埋める。
 */
export const appendUnregisteredPublishedRoomRows = ({
	rows,
	publishedRooms,
	dates,
	adultNums,
}: {
	rows: PlanRoomDailyRateRow[];
	publishedRooms: PublishedRoom[];
	dates: string[];
	adultNums: number[];
}): PlanRoomDailyRateRow[] => {
	const rankRow = rows.find((row) => row.planID === CHILLNN_ROOM_RANK_PLAN_ID);
	const roomRateRow = rows.find((row) => row.planID === ROOM_RATE_PLAN_ID);
	const template = rankRow ?? roomRateRow;
	const planID = template?.planID ?? CHILLNN_ROOM_RANK_PLAN_ID;
	const presentRoomIDs = new Set(
		(template ? rows.filter((row) => row.planID === planID) : rows).map((row) => row.roomID),
	);
	const missingRooms = publishedRooms.filter((room) => !presentRoomIDs.has(room.roomID));
	if (missingRooms.length === 0) {
		return rows;
	}

	const planName =
		template?.planName ??
		(planID === ROOM_RATE_PLAN_ID ? ROOM_RATE_PLAN_NAME : CHILLNN_ROOM_RANK_PLAN_NAME);
	const priceSource = template?.priceSource ?? "chillnn_room_rank";

	const buildUnregisteredCells = (): PlanRoomDailyRateRow["cellsByDate"] => {
		const cellsByDate: PlanRoomDailyRateRow["cellsByDate"] = {};
		for (const date of dates) {
			const guestCells: NonNullable<PlanRoomDailyRateRow["cellsByDate"][string]> = {};
			for (const adultNum of adultNums) {
				guestCells[adultNum] = unregisteredCell;
			}
			cellsByDate[date] = guestCells;
		}
		return cellsByDate;
	};

	return [
		...rows,
		...missingRooms.map((room) => ({
			id: `unregistered-${planID}-${room.roomID}`,
			planID,
			planName,
			isSCConnected: template?.isSCConnected ?? false,
			isDayTrip: false,
			roomID: room.roomID,
			roomName: room.roomName,
			isDummyRoom: false,
			priceSource,
			salePeriodLabel: "販売中",
			cellsByDate: buildUnregisteredCells(),
		})),
	];
};
